import { Navigate, useRoutes } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';

// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import UserMst from './ASK/MastersForDB/UserMst';
import BuyerMasters from './ASK/MastersForDB/BuyerMasters';
import GarmentDescription from './ASK/MastersForDB/GarmentDescription';
import Machine from './ASK/MastersForDB/Machine';
import Line from './ASK/MastersForDB/Line';
import OpeationCategory from './ASK/MastersForDB/OpeationCategory';
import OperationGroup from './ASK/MastersForDB/OperationGroup';
import Operation from './ASK/MastersForDB/Operation';
import GarmentCategoryMst from './ASK/MastersForDB/GarmentCategoryMst';
import DepartmentMst from './ASK/MastersForDB/DepartmentMst';
import DesignationMst from './ASK/MastersForDB/DesignationMst';
import FactorySmv from './ASK/MastersForDB/FactorySmv';
import FactoryExpense from './ASK/MastersForDB/FactoryExpense';
import ProcessMst from './ASK/MastersForDB/ProcessMst';
import AddOB from './OB/AddOB';
import ManageOB from './OB/ManageOB';
import RateCard from './ASK/MastersForDB/RateCard';
import ManageTB from './OB/ManageTB';
import AddTimeStudy from './OB/AddTimeStudy';
import ManageRateCard from './OB/ReteCard/ManageRateCard';
import AddStyleRateCard from './OB/ReteCard/AddStyleRateCard';
import ManageApproveRateCard from './OB/ReteCard/ManageApproveRateCard';
import ManageDB from './OB/DailyProduction/ManageDB';
import ManageOP from './OB/ProcessProduction/ManageOP';
import OtherProcess from './OB/ProcessProduction/OtherProcess';

// import AddDB from './OB/DailyProduction/AddDailyProduction';
import ProdutionUnitMasters from './ASK/MastersForDB/ProdutionUnitMasters';
import ManagePR from './OB/PrProduction/ManagePR';
import AddDailyProduction from './OB/DailyProduction/AddDailyProduction';
import AddPRProduction from './OB/PrProduction/AddPRProduction';
import PRProductionReports from './Reports/PRProductionReports';
import CompanyMasters from './ASK/MastersForDB/CompanyMasters';
import PrProductionHourlyReports from './Reports/PrProductionHourlyReports';
import EmployeeWiseEarningReports from './Reports/EmployeeWiseEarningReport';
import DailyProductionHourlyReport from './Reports/DailyProductionHourlyReport';
import PRSkillMatrix from './Reports/PRSkillMatrix';
import MonthWiseProductionReport from './Reports/MonthWiseProductionReport';
import DailySkillMatrix from './Reports/DailySkillMatrix';
import AccessControl from './ASK/MastersForDB/AccessControl';
import ControlCenter from './ASK/MastersForDB/ControlCenter';
import OBStatusReport from './Reports/OBStatusReport';
import DailyReportTracker from './Reports/DailyReportTrackerReport';
import DayWiseProductionCostReport from './Reports/DayWiseProductionCostReport';
import ProcessTrackerReport from './Reports/ProcessTrackerReport';
import GradeMst from './ASK/MastersForDB/GradeMst';
import FactoryExpenseReport from './Reports/FactoryExpenseReport';
import ProcessEmpMap from './Reports/ProcessEmpMap';
import ManpowerReport from './Reports/ManpowerReport';
// ----------------------------------------------------------------------

const isAuthenticated = () => {
  const loginStatus = sessionStorage.getItem('LoginStatus');
  return loginStatus === 'Y';
};

// const hasAccess = (screenName) => {
//   const access = sessionStorage.getItem(`${screenName}`) === 'Y';
//   return access;
// };

const hasAccess = (screenName) => {
  const isSplUser = sessionStorage.getItem('SplUser') === 'Y';
  if (isSplUser) {
    return true; // Grant access to all screens if SplUser is 'Y'
  }
  return sessionStorage.getItem(screenName) === 'Y';
};

// ProtectedRoute HOC
const ProtectedRoute = ({ element, screenName }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (!hasAccess(screenName)) {
    return <Page404 />;
  }
  return element;
};

// for  techvel dashboard
export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: (
        <>
          <Helmet>
            <title>Quick OB | Dashboard</title>
          </Helmet>
          <DashboardLayout />
        </>
      ),
      children: [
        { path: 'home', element: <DashboardAppPage />, shortname: 'Dashboard' },
        // production
        { path: 'masters/GarmentCategoryMst', element: <GarmentCategoryMst />, shortname: 'Masters_GarmentType' },
        { path: 'masters/GarmentDescription', element: <GarmentDescription />, shortname: 'Masters_Garments' },
        { path: 'masters/category', element: <OpeationCategory />, shortname: 'Masters_GarmentCategory' },
        { path: 'masters/machine', element: <Machine />, shortname: 'Masters_Machine' },
        { path: 'masters/group', element: <OperationGroup />, shortname: 'Masters_OperationGroup' },
        { path: 'masters/operation', element: <Operation />, shortname: 'Masters_Operation' },
        { path: 'masters/rate_card', element: <RateCard />, shortname: 'Masters_RateCard' },
        { path: 'masters/line', element: <Line />, shortname: 'Masters_Batch_Line' },
        { path: 'masters/grade', element: <GradeMst />, shortname: 'Masters_grade' },

        // Configuration
        { path: 'masters/buyer', element: <BuyerMasters />, shortname: 'Masters_Buyer' },
        { path: 'masters/company', element: <CompanyMasters />, shortname: 'Masters_Company' },
        { path: 'masters/production_unit', element: <ProdutionUnitMasters />, shortname: 'Masters_FactoryUnit' },
        { path: 'masters/DepartmentMst', element: <DepartmentMst />, shortname: 'Masters_Department' },
        { path: 'masters/DesignationMst', element: <DesignationMst />, shortname: 'Masters_Designation' },
        { path: 'masters/users_access_control', element: <UserMst />, shortname: 'Masters_UserPreviledges' },
        { path: 'masters/user_screen_access_control', element: <AccessControl />, shortname: 'Masters_AccessSettings' },
        { path: 'masters/controlcenter', element: <ControlCenter />, shortname: 'Masters_ControlCenter' },
        { path: 'masters/factory_smv', element: <FactorySmv />, shortname: 'Masters_FactorySMV' },
        { path: 'masters/factory_expense', element: <FactoryExpense />, shortname: 'Masters_FactoryExpense' },
        { path: 'masters/process', element: <ProcessMst />, shortname: 'Masters_ProcessMst' },

        // OBProduction
        { path: 'manage/operation_bulletin', element: <ManageOB />, shortname: 'Transaction_OperationBulletin' },
        { path: 'manage/operation_bulletin/add', element: <AddOB />, shortname: 'Transaction_OperationBulletin' },
        { path: 'manage/operation_bulletin/edit/:id', element: <AddOB />, shortname: 'Transaction_OperationBulletin' },
        { path: 'manage/operation_bulletin/edit/:id/:type', element: <AddOB />, shortname: 'Transaction_OperationBulletin', },
        { path: 'manage/time_and_study', element: <ManageTB />, shortname: 'Transaction_Time_and_Study' },
        { path: 'manage/time_and_study/add', element: <AddTimeStudy />, shortname: 'Transaction_Time_and_Study' },
        { path: 'manage/time_and_study/edit/:id', element: <AddTimeStudy />, shortname: 'Transaction_Time_and_Study' },
        { path: 'manage/time_and_study/edit/:id/:type', element: <AddTimeStudy />, shortname: 'Transaction_Time_and_Study', },
        { path: 'manage/daily_production', element: <ManageDB />, shortname: 'Transaction_DailyProduction' },
        { path: 'manage/daily_production/add', element: <AddDailyProduction />, shortname: 'Transaction_DailyProduction', },
        { path: 'manage/daily_production/edit/:id', element: <AddDailyProduction />, shortname: 'Transaction_DailyProduction', },
        { path: 'manage/other_production', element: <ManageOP />, shortname: 'Transaction_OtherProduction' },
        { path: 'manage/other_production/add', element: <OtherProcess />, shortname: 'Transaction_OtherProduction', },
        { path: 'manage/other_production/edit/:id', element: <OtherProcess />, shortname: 'Transaction_OtherProduction', },
        { path: 'reports/daily_production_hourly', element: <DailyProductionHourlyReport />, shortname: 'Reports_HourlyProduction', },
        { path: 'reports/OBStatus', element: <OBStatusReport />, shortname: 'Reports_ObStatus', },
        { path: 'reports/ReportTracker', element: <DailyReportTracker />, shortname: 'Reports_ReportTracker', },
        { path: 'reports/DayWiseProductionCostReport', element: <DayWiseProductionCostReport />, shortname: 'Reports_DayWiseProductionCostReport', },
        { path: 'reports/monthly_wise_production', element: <MonthWiseProductionReport />, shortname: 'Reports_MonthlyProduction', },
        { path: 'reports/daily_skillmatrix', element: <DailySkillMatrix />, shortname: 'Reports_SkillMatrixDaily' },
        { path: 'reports/employee_wise_production', element: <EmployeeWiseEarningReports />, shortname: 'Reports_EmployeeWiseEarning', },
        { path: 'reports/process_tracker', element: <ProcessTrackerReport />, shortname: 'Reports_ProcessTracker', },
        { path: 'reports/factoryexpensereport', element: <FactoryExpenseReport />, shortname: 'Reports_factoryexpensereport', },
        { path: 'reports/ProcessEmpMap', element: <ProcessEmpMap />, shortname: 'Reports_ProcessEmpMap', },
        { path: 'reports/ManpowerReport', element: <ManpowerReport />, shortname: 'Reports_ManpowerReport', },

        // PR Production
        { path: 'manage/style_rate_card', element: <ManageRateCard />, shortname: 'Transaction_StyleRateCard' },
        { path: 'manage/style_rate_card/add', element: <AddStyleRateCard />, shortname: 'Transaction_StyleRateCard' },
        {
          path: 'manage/style_rate_card/edit/:id/:id1',
          element: <AddStyleRateCard />,
          shortname: 'Transaction_StyleRateCard',
        },
        {
          path: 'manage/style_rate_card_approve/manage',
          element: <ManageApproveRateCard />,
          shortname: 'Transaction_SRCApproval',
        },
        {
          path: 'manage/style_rate_card_approve/:type/:id',
          element: <AddStyleRateCard />,
          shortname: 'Transaction_SRCApproval',
        },
        { path: 'manage/pr_production', element: <ManagePR />, shortname: 'Transaction_PRProduction' },
        { path: 'manage/pr_production/add', element: <AddPRProduction />, shortname: 'Transaction_PRProduction' },
        { path: 'manage/pr_production/edit/:id', element: <AddPRProduction />, shortname: 'Transaction_PRProduction' },
        { path: 'reports/pr_production', element: <PRProductionReports />, shortname: 'Reports_ProductionReportCard' },
        {
          path: 'reports/pr_production_hourly',
          element: <PrProductionHourlyReports />,
          shortname: 'Reports_ProductionHrsWise',
        },
        { path: 'reports/pr_skillmatrix', element: <PRSkillMatrix />, shortname: 'Reports_SkillMatrixPR' },
      ].map((route) => ({
        ...route,
        element: <ProtectedRoute element={route.element} screenName={route.shortname} />,
      })),
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ].map((route) => ({ ...route, element: <ProtectedRoute element={route.element} /> })),
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
    {
      path: 'login',
      element: (
        <>
          <Helmet>
            <title>Quick OB | Login</title>
          </Helmet>
          <LoginPage />
        </>
      ),
    },
  ]);

  return routes;
}
